export default __webpack_public_path__ + "static/media/bw.eaa1eca3.svg";